import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import ErrorBoundary from 'gatsby-theme-core/src/components/error-boundary';

const getSlot = (type) => {
  switch (type) {
    case 'block':
      return '6109570013';
    case 'vertical':
      return '5343283258';
    case 'horizontal':
      return '6294818339';
    case 'flexible':
    default:
      return '4204036348';
  }
};

const Ad = ({ className, type }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  const slot = getSlot(type);

  return (
    <ErrorBoundary>
      <div className={className}>
        <ins
          className="adsbygoogle"
          data-ad-client="ca-pub-4840906894720059"
          data-ad-slot={slot}
          data-ad-format={type !== 'horizontal' ? 'auto' : null}
          data-full-width-responsive={type !== 'horizontal' ? 'true' : null}
        />
      </div>
    </ErrorBoundary>
  );
};

export default styled(Ad)`
  text-align: center;
  ins {
    display: inline-block;
    width: 100%;
    ${({ type }) => type === 'horizontal' && css`
      width: 728px;
      height: 90px;
    `}
  }
`;
